import {Button} from '@gongxigames/framework/core/fragments/display/Button';
import {AUTOMATION_META, AutomationMeta} from '@gongxigames/framework/core/fragments/Autotest';

export class Checkbox {

    protected _onButton: Button;
    protected _offButton: Button;
    protected _changedCallback?: Function;
    protected _isOn = false;
    protected _enabled = true;

    constructor(onButton: Button, offButton: Button, changedCallback?: Function) {
        this._onButton = onButton;
        this._offButton = offButton;
        this._changedCallback = changedCallback;

        this._onButton.callback = this.onOnButtonClicked.bind(this);
        this._offButton.callback = this.onOffButtonClicked.bind(this);

        this.updateState();
    }

    protected onOnButtonClicked(): void {
        this.setValue(false, true);
    }

    protected onOffButtonClicked(): void {
        this.setValue(true, true);
    }

    public setDisabled(disabled: boolean): void {
        this._enabled = !disabled;
        this._onButton.setDisabled(disabled);
        this._offButton.setDisabled(disabled);
    }

    public enable(): void {
        this.setDisabled(false);
    }

    public disable(): void {
        this.setDisabled(true);
    }

    public hide(): void {
        this._onButton.visible = false;
        this._offButton.visible = false;
    }

    public show(): void {
        this.updateState();
    }

    public set changedCallback(value: Function) {
        this._changedCallback = value;
    }

    public setValue(isOn: boolean, callCallback = false): void {
        this._isOn = isOn;
        this.updateState();

        if (callCallback && this._enabled) {
            this._changedCallback?.(isOn);
        }
    }

    protected updateState(): void {
        this._onButton.visible = this._isOn;
        this._offButton.visible = !this._isOn;
    }

    public get value(): boolean {
        return this._isOn;
    }

    public set value(isOn: boolean) {
        this.setValue(isOn, true);
    }

    [AUTOMATION_META](): AutomationMeta {
        return {
            type: 'checkbox',
            disabled: !this._enabled,
            checked: this._isOn
        };
    }
}
